import React from 'react';

import { RoutePermittedRole } from '@crema/constants/AppEnums';
import BlankPage from 'libs/modules/src/lib/blankPage';

const ProjectManagement = React.lazy(() => import('../../modules/orderManagement/Project/ProjectList'));

const ProjectDetail = React.lazy(() => import('../../modules/orderManagement/Project/ProjectDetail'));

const OrderList = React.lazy(() => import('../../modules/orderManagement/order/List'));

const OrderDetail = React.lazy(() => import('../../modules/orderManagement/order/Detail'));

export const orderManagementPageConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/projects',
    element: <ProjectManagement />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/projects/detail',
    element: <ProjectDetail />,
  },
  {
    permittedRole: [RoutePermittedRole.User],
    path: '/orders',
    element: <OrderList />,
  },
  {
    permittedRole: [RoutePermittedRole.User],
    path: '/orders/detail',
    element: <OrderDetail />,
  },
];
